/**
 * CC Cart Upsell — "+ ADD" handler.
 * Document-level event delegation survives the cart components' server
 * re-renders (the card is morphed in/out on every cart change), so no
 * re-binding is ever needed. Success feedback is the suppression rule:
 * the post-add morph re-evaluates the Liquid guard and removes the card.
 */
import { CartAddEvent } from '@theme/events';

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-cc-upsell-add]');
  if (!button || button.disabled) return;

  const variantId = button.dataset.variantId;
  if (!variantId) return;

  const errorEl = button.parentElement.querySelector('[data-cc-upsell-error]');
  if (errorEl) errorEl.hidden = true;
  button.disabled = true;

  const formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', '1');

  // Atelier's bundled section rendering contract — same as cc-atc-drawer.js
  const sectionIds = Array.from(
    document.querySelectorAll('cart-items-component[data-section-id]')
  )
    .map((el) => el.getAttribute('data-section-id'))
    .filter(Boolean);
  if (sectionIds.length) formData.append('sections', sectionIds.join(','));

  const addUrl =
    (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add';

  fetch(addUrl, {
    method: 'POST',
    headers: { Accept: 'application/javascript' },
    body: formData,
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.status) throw new Error(data.description || 'Cart add failed');
      document.dispatchEvent(
        new CartAddEvent({}, 'cc-cart-upsell', {
          source: 'product-form-component',
          variantId: String(variantId),
          sections: data.sections,
        })
      );
      // No button reset: the morph removes the card via suppression.
    })
    .catch((error) => {
      console.error('CC cart upsell:', error);
      button.disabled = false;
      if (errorEl) errorEl.hidden = false;
    });
});
